import createClient from "openapi-fetch";
import { DEFAULT_ROBOTOFF_API_URL, USER_AGENT } from "./consts.js";
import { formBody } from "./formbody.js";
export class Robotoff {
    constructor(fetch, options = { baseUrl: DEFAULT_ROBOTOFF_API_URL }) {
        this.fetch = fetch;
        this.raw = createClient({
            fetch: this.fetch,
            baseUrl: options.baseUrl,
            headers: {
                "User-Agent": USER_AGENT,
            },
        });
    }
    async annotate(body) {
        return this.raw.POST("/insights/annotate", {
            body: body,
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            bodySerializer: formBody,
        });
    }
    questionsByProductCode(code, query) {
        return this.raw.GET("/questions/{barcode}", {
            params: { path: { barcode: code }, query: query },
        });
    }
    insightDetail(id) {
        return this.raw.GET("/insights/detail/{insight_id}", {
            params: { path: { insight_id: id } },
        });
    }
    /**
     * Fetches insights based on the provided query.
     *
     * @param {RobotoffInsightQuery} query - The query object containing parameters for fetching insights.
     * @returns A promise that resolves to the data from the insights endpoint
     *
     */
    insights(query) {
        return this.raw.GET("/insights", { params: { query } });
    }
    // TODO: replace any with proper type
    // ATM not specifying the type makes tsc fail sometimes
    async loadLogo(logoId) {
        // @ts-expect-error TODO: still not documented
        const result = await this.raw.GET("/images/logos/{logoId}", {
            params: { path: { logoId } },
        });
        return result.data;
    }
}
//# sourceMappingURL=robotoff.js.map